import React from "react";
//Limitless imports
import { useNotificationContext } from "@limitless/common/hooks/notification/NotificationContext";
import { log as pilog } from "@limitless/common/utils";
import { fetchPaymentHistory, processWithdrawal } from "../../../portal";
import { useExpertProfileContext } from "../expert-profile/ExpertProfileContext";
const INITIAL_FILTERS = {
  hasFilter: false,
  selectedGroups: [],
  rewardTypes: {
    responded: null,
    forwarded: null,
    reviewed: null
  },
  status: {
    inProgress: null,
    awaitingPayment: null
  }
};
const INITIAL_STATE = {
  loading: false,
  history: [],
  filteredHistory: [],
  errorDetails: {},
  nextWithdrawalTime: null,
  successText: "",
  availableGroups: []
};
export const useExpertPayments = () => {
  const log = pilog.getLogger("useExpertPayments");
  const [payments, setPayments] = React.useState(INITIAL_STATE);
  const [rewardFilters, setRewardFilters] = React.useState(INITIAL_FILTERS);
  const {
    profile,
    updateProfile
  } = useExpertProfileContext();
  const {
    addSuccessNotification
  } = useNotificationContext();
  log.debug(payments);
  const updateRewardFilters = filter => {
    setRewardFilters({
      ...rewardFilters,
      filter
    });
  };
  const loadExpertPayments = () => {
    setPayments({
      ...payments,
      loading: true
    });
    fetchPaymentHistory(response => {
      log.debug(response);
      if (!response.hasError) {
        const resHistory = response.history.map(item => ({
          ...item,
          displayState: item.state === "req_approval" ? "requested" : item.state
        }));
        setPayments({
          ...payments,
          loading: false,
          history: resHistory,
          errorDetails: {},
          nextWithdrawalTime: null
        });
      } else {
        setPayments({
          history: [],
          errorDetails: response,
          nextWithdrawalTime: null,
          loading: false
        });
      }
    });
  };
  const validateProfileState = () => {
    if (!profile.paypalAccount) {
      setPayments({
        ...payments,
        nextWithdrawalTime: null,
        errorDetails: {
          meaning: "Please add your PayPal address to your profile"
        },
        loading: false
      });
      return false;
    }
    return true;
  };
  const requestWithdrawal = () => {
    log.debug("Request withdrawal");
    const canMakeRequest = validateProfileState();
    if (canMakeRequest) {
      setPayments({
        ...payments,
        loading: true
      });
      processWithdrawal(profile.balance, response => {
        log.debug(response);
        if (response.hasError) {
          setPayments({
            ...payments,
            errorDetails: response,
            nextWithdrawalTime: null,
            loading: false
          });
        } else {
          //reload the payments
          loadExpertPayments();
          updateProfile({
            balance: response.postBalance
          });
          addSuccessNotification("Payment request successful");
        }
      });
    }
  };
  return {
    loadExpertPayments,
    payments,
    requestWithdrawal,
    updateRewardFilters,
    rewardFilters
  };
};